export enum DataType {
    Integer = 'int',
    Double = 'double',
    Numeric = 'int || double',
    String = 'string',
    Boolean = 'boolean',
    DateTime = 'datetime',
}
